import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const faqItems = [
  {
    question: "What is an Adult Family Home?",
    answer: "An Adult Family Home (AFH) is a residential home licensed to provide personal care and housing for up to 6 adults. Unlike large facilities, AFHs offer a home-like environment with consistent caregivers who truly get to know each resident. It's care that feels like family."
  },
  {
    question: "How is an AFH different from a nursing home or assisted living?",
    answer: "Adult Family Homes offer a much smaller, more intimate setting than nursing homes or assisted living facilities. With only 2-6 residents, your loved one receives personalized attention from caregivers who know them by name, their preferences, and their routines—not rotating staff who change every shift."
  },
  {
    question: "What happens during a tour?",
    answer: "During your private tour, you'll meet our caregivers, see the living spaces, and learn about our daily routines. We encourage you to ask questions, observe the atmosphere, and see how we interact with current residents. There's no pressure—it's about finding the right fit for your family."
  },
  {
    question: "How do I know if my loved one is a good fit?",
    answer: "We assess each potential resident individually to ensure we can meet their care needs and that they'll thrive in our home environment. Factors include care requirements, compatibility with current residents, and whether our home's atmosphere matches what your family is looking for."
  },
  {
    question: "What are the costs and payment options?",
    answer: "Costs vary based on the level of care required. We accept private pay and work with long-term care insurance. We also accept Medicaid for qualifying residents. During your tour, we'll discuss your specific situation and provide transparent pricing with no hidden fees."
  },
];

export function FAQSection() {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="eyebrow text-accent-strong">Common Questions</span>
          <h2 className="mt-4 display-md font-heading font-semibold tracking-[-0.025em] text-foreground">
            Frequently asked{" "}
            <span className="font-display-italic font-normal text-accent-strong">questions</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            We understand you have questions. Here are answers to the most common ones families ask.
          </p>
        </div>

        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="rounded-2xl border border-border/50 bg-card px-6 shadow-sm"
              >
                <AccordionTrigger className="text-left font-medium text-foreground hover:no-underline py-5">
                  <div className="flex items-start gap-3">
                    <HelpCircle className="h-5 w-5 text-accent-strong mt-0.5 shrink-0" />
                    <span>{item.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 pl-8">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
